module.exports = __webpack_public_path__ + "img/172.e55c407e.jpg";